// extracted by mini-css-extract-plugin
module.exports = {"wrap":"TitleSlide_wrap__sxDgR","fadeIn":"TitleSlide_fadeIn__2nsrW","slogan":"TitleSlide_slogan__gelu-","fadein":"TitleSlide_fadein__3r5fR"};